import { render, staticRenderFns } from "./AddProductToClientOrder.vue?vue&type=template&id=4917f4d6&scoped=true&"
import script from "./AddProductToClientOrder.vue?vue&type=script&lang=js&"
export * from "./AddProductToClientOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4917f4d6",
  null
  
)

export default component.exports